
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}},[_c('path',{attrs:{"fill":"#e48174","d":"M30.48 20.73L20.22 6.05c-7.59-3.89-13.6-4.52-18.06-1.9-.06.22-.13.44-.18.66C-.67 15.43 5.8 26.19 16.42 28.84c4.99 1.24 10 .48 14.2-1.78l-.14-6.33z"}})])
      }
    
      }
    